import PropTypes from 'prop-types'
import React from 'react'

export const Location = ({ country, city, location, closerLocation }) =>
  <div className='oglasi-dodatne-informacije'>
    <div className='oglasi-info-heading'>
      <p>Lokacija oglasa</p>
    </div>
    <div>
      <ul>
        <li>
          <p>Drzava</p>
          <span>{country}</span>
        </li>
        <li>
          <p>Grad</p>
          <span>{city}</span>
        </li>
        <li>
          <p>Lokacija</p>
          <span>{location}</span>
        </li>
        {closerLocation ? (
          <li>
            <p>Bliža Lokacija</p>
            <span>{closerLocation}</span>
          </li>) : null}
      </ul>
    </div>
  </div>

Location.propTypes = {
  city: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  closerLocation: PropTypes.string
}

Location.defaultProps = {
  city: '',
  country: '',
  location: ''
}
